<div bsModal class="modal fade" id="showConversionHintDialog{{context}}" role="dialog" tabindex="-1">
  <div class="modal-dialog modal-lg modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h3 class="modal-title pull-left">{{ 'COMMON_UI.HINWEIS_UMSTELLUNG.TITEL' | translate }}</h3>
      </div>
      <div class="modal-body">
        <div class="modal-body-block">
          <p>
            {{ 'COMMON_UI.HINWEIS_UMSTELLUNG.ABSATZ_1' | translate }}
          </p>
        </div>
        <!--<div class="modal-body-block">
          <p>
            {{ 'COMMON_UI.HINWEIS_UMSTELLUNG.ABSATZ_2' | translate }}
            <a [href]="versionChangeLink" rel="noopener noreferrer" target="_blank">
              {{'COMMON_UI.HINWEIS_UMSTELLUNG.LINK_TEXT' | translate }}
            </a>
          </p>
        </div>-->
        <div class="d-flex flex-row p-2 justify-content-end mt-4">
          <button (click)="onConfirmHint()" class="btn btn-primary"
                  type="button">{{ 'COMMON_UI.HINWEIS_UMSTELLUNG.CONFIRM' | translate }}</button>
        </div>
      </div>
    </div>
  </div>
</div>

